const EVENTS_KEY = 'lb_events';
const EVENT_DETAILS_PREFIX = 'lb_event_details_';
const CAMPAIGNS_KEY = 'lb_campaigns';
const CAMPAIGN_DETAILS_PREFIX = 'lb_campaign_details_';
const PENDING_SCANS_KEY = 'lb_pending_scans';

function read(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (_) {
    return fallback;
  }
}

function write(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (_) {}
}

function ticketsKey(eventId) {
  return `lb_tickets_${eventId}`;
}

export const OfflineCache = {
  saveEvents(events) {
    write(EVENTS_KEY, events || []);
  },
  getEvents() {
    return read(EVENTS_KEY, []);
  },
  saveEventDetail(eventId, eventDetail) {
    write(`${EVENT_DETAILS_PREFIX}${eventId}`, eventDetail || null);
  },
  getEventDetail(eventId) {
    return read(`${EVENT_DETAILS_PREFIX}${eventId}`, null);
  },
  // Campaigns
  saveCampaigns(campaigns) {
    write(CAMPAIGNS_KEY, campaigns || []);
  },
  getCampaigns() {
    return read(CAMPAIGNS_KEY, []);
  },
  saveCampaignDetail(campaignId, detail) {
    write(`${CAMPAIGN_DETAILS_PREFIX}${campaignId}`, detail || null);
  },
  getCampaignDetail(campaignId) {
    return read(`${CAMPAIGN_DETAILS_PREFIX}${campaignId}`, null);
  },
  saveEventTickets(eventId, tickets) {
    write(ticketsKey(eventId), tickets || []);
  },
  getEventTickets(eventId) {
    return read(ticketsKey(eventId), []);
  },
  addPendingScan(scan) {
    const list = read(PENDING_SCANS_KEY, []);
    const idx = list.findIndex(
      s => s.eventId === scan.eventId && s.ticketId === scan.ticketId
    );
    if (idx >= 0) {
      list[idx] = { ...list[idx], ...scan };
    } else {
      list.push(scan);
    }
    write(PENDING_SCANS_KEY, list);
  },
  getAllPendingScans() {
    return read(PENDING_SCANS_KEY, []);
  },
  getPendingScansForEvent(eventId) {
    const list = read(PENDING_SCANS_KEY, []);
    return list.filter(s => s.eventId === eventId);
  },
  clearPendingScansForEvent(eventId) {
    const list = read(PENDING_SCANS_KEY, []);
    const next = list.filter(s => s.eventId !== eventId);
    write(PENDING_SCANS_KEY, next);
  },
  applyPendingScansToTickets(tickets, pending) {
    if (!Array.isArray(tickets) || !Array.isArray(pending)) return tickets || [];
    const map = new Map();
    for (const t of tickets) map.set(t.ticketId, t);
    for (const p of pending) {
      const item = map.get(p.ticketId);
      if (item) {
        item.scanned = p.scanned;
        if (p.scannedAt) item.scannedAt = p.scannedAt;
      }
    }
    return Array.from(map.values());
  },
};


